const css = require('./desktop.scss');
const {toggleClass} = require('../../utils');

module.exports = {
  markCurrentMenuItem() {
    const mainListItems = document.querySelectorAll(`.${css.navigationItem}`);
    for (let index = 0; index < mainListItems.length; index++) {
      if (mainListItems[index].querySelector(`a[href$="${location.pathname}"]`)) {
        toggleClass(mainListItems[index], css.active, true);
        break;
      }
    }
  }
};



// WEBPACK FOOTER //
// ./templates/header/desktopUtils.js